<template>
  <div class="confirmmodal">
    <div class="confirmmodal__container">
      <a @click="$emit('close')" @keyup.enter="$emit('close')" class="confirmmodal__abort" tabindex="0">Avbryt</a>
      <Loader v-if="showLoader" color="white" transparency="0.5" />
      <h2 class="confirmmodal__title text-t3">Granska och skicka din intresseanmälan</h2>

      <div class="confirmmodal__object">
        <div class="confirmmodal__object__wrapper">
          <div class="confirmmodal__object__image" v-if="rentalObj.images && rentalObj.images[0]" :style="{backgroundImage:`url(${rentalObj.images[0]['url']})`}"></div>
          <div>
            <h3 class="confirmmodal__object__adress">
              <span v-if="rentalObj.staircase">{{address}}, </span>
              <span v-else>{{address}}</span>
              <span
                v-if="rentalObj.staircase && rentalObj.staircase!='BV'">våning {{rentalObj.staircase}}</span>
              <span v-if="rentalObj.staircase=='BV'">{{rentalObj.staircase}}</span>
            </h3>
            <p class="confirmmodal__object__area">{{rentalObj.neigbourhood}}</p>
          </div>
        </div>
        <div class="confirmmodal__object__info">
          <span v-if="rentalObj.subCaption">{{rentalObj.subCaption}}</span>
          <span v-if="rentalObj.quantityBRA && rentalObj.objectType != RENTALOBJECT_TYPES.PARKING">{{rentalObj.quantityBRA}} m²</span>
          <span v-if="rentalObj.monthRent">{{addSpace(getPrice(rentalObj))}} kr</span>
          <span v-if="rentalObj.parkingNumber">Platsnummer {{rentalObj.parkingNumber}}</span>

          <div class="confirmmodal__object__flex">
            <div class="confirmmodal__object__rentalmarker" v-if="rentalObj.rentalObjectTypeCaption">{{rentalObj.rentalObjectTypeCaption}}</div>
            <div class="confirmmodal__object__date">Tillträde: <span>{{vacantFromText}}</span></div>
          </div>
        </div>
      </div>

      <div class="confirmmodal__details">
        <h3 class="confirmmodal__details__title text-t6">Dina kontaktuppgifter</h3>
        <ContactInfoForm :profile="profile"/>
      </div>

      <p class="confirmmodal__subtypeinfo" v-if="!!applyinfo">{{applyinfo}}</p>
      <div class="confirmmodal__buttons">
        <button class="confirmmodal__button confirmmodal__button--cancel" tabindex="0"  @click="$emit('close')">Avbryt</button>

        <button v-if="profile.email" class="confirmmodal__button confirmmodal__button--confirm" tabindex="0" :disabled="disable"  @click="this.showLoader = true; $emit('confirmSend')">Skicka</button>
        <button v-else class="confirmmodal__button confirmmodal__button--confirm" tabindex="0" :disabled="disable"  @click="submit()">Skicka</button>
      </div>

    </div>
    <div class="confirmmodal__background"></div>

  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import Loader from '@/components/ui/loader'
import ContactInfoForm from '@/components/profile/contact-info-form'
import { RENTALOBJECT_TYPES, PARKING_FILTER_TYPES } from '@/config/constants'
import dayjs from 'dayjs'

export default {
  components: { Loader, ContactInfoForm },
  props: {
    rentalObj: {
      type: Object,
    },
  },
  data(){
    return {
      showLoader: false,
      editableProfile: {},
      RENTALOBJECT_TYPES,
    }
  },
  watch: {
    profile: {
      deep:true,
      immediate:true,
      handler(profile){
        this.editableProfile = {...profile};
      }
    }
  },
  methods:{
    addSpace (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },

    isCar(rentalObj) {
      return PARKING_FILTER_TYPES['CAR'].includes(rentalObj.realEstateObjectTypeCode) || PARKING_FILTER_TYPES['CAR'].includes(rentalObj.rentalObjectType);
    },

    getPrice(rentalObject) {
      if (this.isCar(rentalObject)) {
        if (rentalObject.vatAdded != true) {
          return Math.round(rentalObject.monthRent * 1.25)
        }
      }
      return rentalObject.monthRent;
    },


    submit(){
      return this.$validator.validateAll().then(result => {
        if (result) {
          this.showLoader = true;

          return this.$store.dispatch('saveProfile', this.editableProfile).then(() => {
            return this.$store.dispatch('fetchProfile')
          }).then((profile) => {
          }).finally(() => {
            this.showLoader = false;
          }).catch((err) => {
            this.showLoader = false;
            const emailError = err.response.data.errors.find(x => x.field === 'email');
            if(emailError && emailError.code === "alreadyExists") {
              this.$validator.errors.add({
                field: 'email',
                msg: "Det finns redan ett konto där e-posten används, vänligen försök igen.",
              });
            }});
        }
      });
    },
  },
  computed:{
    ...mapGetters({
      profile: 'profile',
      authStatus: 'authStatus',
      address : 'address'
    }),

    disable() {
      if(!this.$store.getters.profile.email || this.$store.getters.profile.preferredContactMethod == 'letter' || this.$store.getters.profile.preferredContactMethod == '' || !!this.showLoader) return true;
    },

    vacantFromText(){
      if (!this.rentalObj || !this.rentalObj.vacantFrom)
        return;

      const formattedDate = dayjs(this.rentalObj.vacantFrom).format('YYYY-MM-DD');

      if (dayjs(formattedDate).isBefore(dayjs()))
        return "Omgående";

      return formattedDate;
    },

    who(){
      const profile = this.$store.getters.profile;

      if(! profile || ! profile.firstName)
        return '';

      return profile.firstName + ' ' + profile.lastName;
    },

    address(){
      return this.rentalObj.address ? this.rentalObj.address : this.rentalObj.address1;
    },

    applyinfo(){
      let type = this.rentalObj.rentalObjectTypeName ? this.rentalObj.rentalObjectTypeName : this.rentalObj.rentalObjectTypeCaption;
      if(type == "Trygghetsboende") return ""
      else if(type == "Startbo") return ""
      else if(type == "Studentbostad") return "Du behöver visa upp intyg på att du är student för att kunna hyra den här bostaden."
      return "";
    }
  },

  created(){
    return Promise.all([
      this.$store.cache.dispatch('fetchProfile'),
    ]).finally(() => {
    })
  }
}
</script>


<style lang="scss">

.confirmmodal {
  position: absolute;
  left: calc(50% - 50vw);
  width: 100vw;
  z-index: 30004;

  @media (min-width: 650px) {
    width: 650px;
    left: calc(50% - 325px);
  }

  @media (min-width: 1024px) {
    left: calc(20% - 50vw);
  }

  @media (min-width: 1450px) {
    left: calc(50% - 50vw);
  }

  &__title {
    font-size: 24px;
    line-height: 1.2;
    text-align: left;
    margin-bottom: 24px;
    padding-bottom: 0;
  }

  &__container {
    position: absolute;
    z-index: 12;
    top: 0;
    left: 0;
    margin: 15px;
    width: calc(100% - 30px);
    max-width: 650px;
    padding: 35px 22px 24px;
    background-color: $backgroundcolorwhite;
    border-radius: 4px;
    box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.1);
    border: solid 2px $lightgray;
    box-sizing: border-box;
  }

  &__subtypeinfo {
    position: relative;
    font-size: 14px;
    line-height: 18.2px;
    margin-left: 29px;
    margin-bottom: 24px;

    &:before {
      content: ' ';
      display: block;
      position: absolute;
      background-size: contain;
      width: 20px;
      height: 20px;
      left: -29px;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-info-black.svg);
    }
  }

  &__object {
    padding: 16px 20px;
    font-size: 14px;
    background-color: $offwhite;
    color: $textcolorblack;
    border-radius: 4px;
    border: solid 1px $lightgray;

    &__wrapper {
      display: flex;
      margin-bottom: 15px;
    }

    &__image {
      width: 55px;
      height: 55px;
      background-size: cover;
      margin-right: 11px;
    }

    &__adress {
      padding-bottom: 0!important;
    }

    &__adress span, h3 span {
      font-size: 18px;
      font-weight: bold!important;
      font-family: $sansserif;
    }

    &__area {
      font-size: 12px;
      text-transform: uppercase;
    }

    &__info {
      span:not(:last-of-type) {
        padding-right: 10px;
        margin-right: 10px;
        border-right: 1px solid #9d9d9c;
      }
    }


    &__flex {
      display: flex;
      margin-top: 16px;
      align-items: center;
      justify-content: space-between;
    }

    &__rentalmarker {
      padding: 5px 8px;
      border-radius: 2px;
      border: solid 1px $gray;
      font-size: 14px;
    }

    &__date {
      font-size: 12px;
      text-transform: uppercase;

      span {
        font-weight: bold;
      }
    }
  }


  &__background {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .4);
    z-index: 11;
  }

  &__details {
    margin: 24px 0 24px 0;
    font-size: 16px;
    text-align: left;
    position: relative;
    border-radius: 6px;
    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px $lightgray;
    background-color: $offwhite;
    padding: 18px 16px;

    &__title {
      font-size: 16px;
    }
  }

  &__abort {
    cursor: pointer;
    width: 24px;
    height: 24px;
    background-position: 0 0;
    background-repeat: no-repeat;
    background: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-close.svg);
    display: block;
    position: absolute;
    top: 24px;
    right: 20px;
    text-indent: -999px;
    overflow: hidden;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: 800px) {
      flex-direction: row;
      justify-content: flex-end;
    }
  }


  &__button {
    cursor: pointer;
    padding: 16px 42px;
    border-radius: 6px;
    border: solid 2px #007893;
    color: $textcolorwhite;
    text-transform: none;
    font-weight: bold;
    font-size: 18px;
    font-family: $sansserif;
    background-color: $abgblue;
    margin-bottom: 16px;
    text-decoration: none;
    transition: all 0.3s;
    outline: none;

    &:hover, &:active {
      background-color: $abghoverblue;
    }


    &--confirm {
      width: 100%;

      @media (min-width: 800px) {
        margin-left: 20px;
        width: auto;
      }

      &:disabled {
        background-color: #9d9d9c;
        border-color: #9d9d9c;
        cursor: default;
      }
    }

    &--cancel {
      border: solid 2px $abgblue;
      background-color: $backgroundcolorwhite;
      color: $abgblue;
      transition: all 0.3s;
      width: 100%;

      &:hover {
        background-color: $abglightblue;
      }


      @media (min-width: 800px) {
        margin-left: 16px;
        width: auto;
      }
    }
  }
}
.emailform {
  padding-bottom: 20px;

  input {
    margin-top: 5px;
    max-width: 300px;
    padding: 8px 19.7px 8px 16px;
    border-radius: 4px!important;
    border: solid 1px $gray;
  }

  &__input-field {
    position: relative;
  }

  &__error {
    position: absolute;
    margin-top: 5px;
    display: block;
  }
}
</style>
